import LoaderIcon from '../assets/loaderio.svg'


const Spinner = () => {
    return (
        <div className='flex--2 loader'>
            <img src={LoaderIcon} alt=''/>
        </div>
    )
}

export default Spinner
